import React, { useState, useCallback } from "react";
import MainToolbar from "./MainToolbar";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Paper,
  Button,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  DialogActions,
} from "@material-ui/core";
import t from "./common/localization";
import EditCollectionView from "./EditCollectionView";
import { formatDate } from "./common/formatter";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import { blue, grey } from "@material-ui/core/colors";
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./store";
import { useDispatch } from "react-redux";
import { deviceCategories } from "./common/deviceCategories";
import SearchBar from "material-ui-search-bar";
import Dialog from "@material-ui/core/Dialog";
import { debounce } from "lodash";
import { DataGrid } from "@material-ui/data-grid";
import SelectField from "./form/SelectField";
import { prefixString } from "./common/stringUtils";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LinkField from "./form/LinkField";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    display: "flex",
    margin: theme.spacing(0.5),
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 688,
  },
  root: {
    padding: '10px',
    margin: '10px',
    marginLeft: '70px',
  },
}));

const DevicesDocuments = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isShowDocuments, setIsShowDocuments] = useState(false);

    const [searchList, setSearchList] = useState([]);
    const [deviceDocuments, setDeviceDocuments] = useState([]);

    const [driverContact, setDriverContact] = useState('');
    const [driverName, setDriverName] = useState('');
    const [category, setCategory] = useState('');
    const [speedLimit, setSpeedLimit] = useState('');
    const [fuelMileage, setFuelMileage] = useState('');
    const [idleDetectTime, setIdleDetectTime] = useState('');
    const [overstayDetectTime, setOverstayDetectTime] = useState('');


  const getResult = async (val) => {
    dispatch(showLoaderStateActions.addState(true));
    const data = { search: val, page: 0, size: 50 };

    const response = await fetch("/api/android/searchDevice", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setSearchList(res);
    }
  };
  const debounceFn = useCallback(debounce(getResult, 1500), []);

  const getAllList = async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch("/api/devices");
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setSearchList(res);
    }
  };

  const searchChange = async (val) => {
    if (val && val.length > 3) {
      debounceFn(val);
    }
  };

  const reset = () => {
    console.log("val");
  };

  const showDocuments = async (device) => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch(
      `/api/devices/${device.value.id}`
    );
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
        const res = await response.json();
        setDeviceDocuments(res);
        
        setDriverContact(res.contact);
        setCategory(res.category);
        setSpeedLimit(res.attributes.speedLimit);
        setFuelMileage(res.attributes.fuelMileage);
        setIdleDetectTime(res.attributes.idleDetectTime);
        setOverstayDetectTime(res.attributes.overstayDetectTime);
    }
    setIsShowDocuments(true);
  };
  const handleClose = () => {
    setIsShowDocuments(false);
  };

  const filterItems = searchList.sort(
    (a, b) =>
      new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime()
  );

  const handleDocumentsSubmit = async (e) => {
    const attributes = {};
    const attributesToRemove = [];
    
    // Check each field and either add to attributes or attributesToRemove
    if (speedLimit) {
      attributes.speedLimit = Number(speedLimit);
    } else {
      attributesToRemove.push("speedLimit");
    }
    
    if (fuelMileage) {
      attributes.fuelMileage = Number(fuelMileage);
    } else {
      attributesToRemove.push("fuelMileage");
    }
    
    if (idleDetectTime) {
      attributes.idleDetectTime = Number(idleDetectTime);
    } else {
      attributesToRemove.push("idleDetectTime");
    }
    
    if (driverName) {
      attributes.driverName = driverName;
    } else {
      attributesToRemove.push("driverName");
    }
    
    if (overstayDetectTime) {
      attributes.overstayDetectTime = Number(overstayDetectTime);
    } else {
      attributesToRemove.push("overstayDetectTime");
    }
    
    // Build the final payload
    const payload = {
      id: deviceDocuments.id,
      name: deviceDocuments.name,
      category, // direct from state
      contact: driverContact, // direct from state
      attributes,
      attributesToRemove
    };
    
    const response = await fetch("/api/android/deviceUpdateAttributesByEndUser", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    if(response.ok){
        handleClose();
    }
  };

  const columns = [
    { field: "name", headerName: t("settingsVehicleNumber"), flex: 1 },
    { field: "creationTime", headerName: "Creation Date", flex: 1 },
    { field: "expirationTime", headerName: "Expiry Date", flex: 1 },
    { field: "status", headerName: t("deviceStatus"), flex: 1 },
    { field: "edit", headerName: "Edit", flex: 1,
      renderCell: (params)=><>
        <div className={classes.iconButtons}>
          <Avatar className={classes.small}>
            {
              <IconButton onClick={(event) => showDocuments(params)}>
                <EditIcon
                  fontSize="small"
                  style={{ color: blue[600] }}
                  />
              </IconButton>
            }
          </Avatar>
        </div>
      </>
     },
    ];
    
  const gridRows = filterItems.map((item, index) => ({
    id: index, // required unique id for DataGrid
    name: item.name,
    creationTime: formatDate(item.creationTime, "MMM D, YYYY"),
    expirationTime: formatDate(item.expirationTime, "MMM D, YYYY"),
    status: item.status,
    edit: item,
}));

  return (
    <>
    <MainToolbar/>
    <div className={classes.root}>
    <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={isShowDocuments}
        PaperProps={{
            sx: {
            width: '700px',
            maxWidth: '100%',
            },
        }}
        >
        <DialogTitle id="simple-dialog-title">{deviceDocuments.name}</DialogTitle>

        <DialogContent>
            <form>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                {/* Expiry Date */}
                <Grid item xs={12}>
                <TextField
                    label="Device Account Expiry Date"
                    value={deviceDocuments.expirationTime || ''}
                    disabled
                    fullWidth
                />
                </Grid>

                {/* Driver Name */}
                <Grid item xs={12} sm={6}>
                <TextField
                    label="Driver Name"
                    value={driverName}
                    onChange={(e) => setDriverName(e.target.value)}
                    fullWidth
                />
                </Grid>
                
                {/* Driver Contact */}
                <Grid item xs={12} sm={6}>
                <TextField
                    label="Driver Contact Number"
                    value={driverContact}
                    onChange={(e) => setDriverContact(e.target.value)}
                    fullWidth
                />
                </Grid>

                {/* Category */}
                <Grid item xs={12}>
                <FormControl fullWidth>
                    <SelectField
                    value={category}
                    emptyValue={null}
                    onChange={(e) => setCategory(e.target.value)}
                    data={deviceCategories.map((category) => ({
                        id: category,
                        name: t(`category${category.replace(/^\w/, (c) => c.toUpperCase())}`),
                    }))}
                    label={t('deviceCategory')}
                    variant="standard"
                    />
                </FormControl>
                </Grid>

                {/* Speed Limit */}
                <Grid item xs={12} sm={6}>
                <TextField
                    label="Speed Limit (km/h)"
                    value={speedLimit}
                    onChange={(e) => setSpeedLimit(e.target.value)}
                    type="number"
                    fullWidth
                />
                </Grid>

                {/* Fuel Mileage */}
                <Grid item xs={12} sm={6}>
                <TextField
                    label="Fuel Mileage (km/l)"
                    value={fuelMileage}
                    onChange={(e) => setFuelMileage(e.target.value)}
                    type="number"
                    fullWidth
                />
                </Grid>

                {/* Idle Detect Time */}
                <Grid item xs={12} sm={6}>
                <TextField
                    label="Idle Detect Time (min)"
                    value={idleDetectTime}
                    onChange={(e) => setIdleDetectTime(e.target.value)}
                    type="number"
                    fullWidth
                />
                </Grid>

                {/* Overstay Detect Time */}
                <Grid item xs={12} sm={6}>
                <TextField
                    label="Overstay Detect Time (min)"
                    value={overstayDetectTime}
                    onChange={(e) => setOverstayDetectTime(e.target.value)}
                    type="number"
                    fullWidth
                />
                </Grid>

                {/* Geofences LinkField */}
                <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <LinkField
                    endpointAll="/api/geofences"
                    endpointLinked={`/api/geofences?deviceId=${deviceDocuments.id}`}
                    baseId={deviceDocuments.id}
                    keyBase="deviceId"
                    keyLink="geofenceId"
                    label={t('sharedGeofences')}
                    variant="standard"
                    />
                </FormControl>
                </Grid>

                {/* Notifications LinkField */}
                <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <LinkField
                    endpointAll="/api/notifications"
                    endpointLinked={`/api/notifications?deviceId=${deviceDocuments.id}`}
                    baseId={deviceDocuments.id}
                    keyBase="deviceId"
                    keyLink="notificationId"
                    titleGetter={(it) => t(prefixString('event', it.type))}
                    label={t('sharedNotifications')}
                    variant="standard"
                    />
                </FormControl>
                </Grid>
            </Grid>
            </form>

            <DialogActions sx={{ mt: 2 }}>
                <Button onClick={handleClose} color="inherit">
                Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleDocumentsSubmit}>
                    Save
                </Button>
            </DialogActions>
        </DialogContent>
        </Dialog>


        <div style={{ marginBottom: "10px", display: "flex" }}>
            <SearchBar
            // value= {'search'}
            onChange={searchChange}
            onCancelSearch={reset}
            placeholder="Search here..."
            className="searchBarInput"
            style={{
                borderRadius: 15,
                height: 35,
                boxShadow: "2px 2px 2px 2px #dbddef",
                fontSize: 12,
                // marginBottom: "10px",
                width: "300px",
            }}
            // onRequestSearch={() => doSomethingWith()}
            />
            <Button
            variant="outlined"
            style={{ marginLeft: "10px" }}
            color="primary"
            onClick={getAllList}
            >
            Show All Devices
            </Button>
        </div>

        {/* <TableContainer className={classes.tContainer} component={Paper}>
            <Table
            stickyHeader
            aria-label="sticky table"
            className={classes.tableAction}
            size="small"
            style={{ whiteSpace: "nowrap" }}
            >
            <TableHead>
                <TableRow className={classes.rowAction}>
                <TableCell className={classes.tCell}>
                    {t("settingsVehicleNumber")}
                </TableCell>
                <TableCell className={classes.tCell}>
                    {t("deviceIdentifier")}
                </TableCell>
                <TableCell className={classes.tCell}>{"VTS Number"}</TableCell>
                <TableCell className={classes.tCell}>
                    {t("deviceModel")}
                </TableCell>
                <TableCell className={classes.tCell}>{"Creation Date"}</TableCell>
                <TableCell className={classes.tCell}>{"Expiry Date"}</TableCell>
                <TableCell className={classes.tCell}>
                    {t("deviceCategory")}
                </TableCell>
                <TableCell className={classes.tCell}>
                    {t("deviceStatus")}
                </TableCell>
                <TableCell className={classes.tCell}>
                    {t("deviceLastUpdate")}
                </TableCell>
                <TableCell className={classes.tCell}>
                    {"Attached Documents"}
                </TableCell>

                <TableCell className={classes.tCell}>{t("deviceSim")}</TableCell>
                <TableCell className={classes.tCell}>{t("deviceApn")}</TableCell>
                <TableCell className={classes.tCell}>{t("driverName")}</TableCell>
                <TableCell className={classes.tCell}>
                    {t("devicesContact")}
                </TableCell>
                <TableCell className={classes.tCell}>
                    {t("reportRemarks")}
                </TableCell>
                <TableCell className={classes.tCell} />
                </TableRow>
            </TableHead>
            <TableBody>
                {filterItems.map((item) => (
                <TableRow hover key={item.id} className={classes.tableRow}>
                    <TableCell>{<b>{item.name}</b>}</TableCell>
                    <TableCell>{item.uniqueId}</TableCell>
                    <TableCell>{item.phone}</TableCell>
                    <TableCell>{item.model}</TableCell>
                    <TableCell>
                    {formatDate(item.creationTime, "MMM D, YYYY")}
                    </TableCell>
                    <TableCell>
                    {formatDate(item.expirationTime, "MMM D, YYYY")}
                    </TableCell>
                    <TableCell>{item.category}</TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>
                    {formatDate(item.lastUpdate, "MMM D, YYYY")}
                    </TableCell>
                    <TableCell>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                        showDocuments(item);
                        }}
                    >
                        Show Documents
                    </Button>
                    </TableCell>
                    <TableCell>{item.attributes.sim}</TableCell>
                    <TableCell>{item.attributes.apn}</TableCell>
                    <TableCell>{item.attributes.driverName}</TableCell>
                    <TableCell>{item.contact}</TableCell>
                    <TableCell>{item.attributes.remarks}</TableCell>
                    <TableCell className={classes.columnAction} padding="none">
                    <div className={classes.iconButtons}>
                        <Avatar className={classes.small}>
                        {
                            <IconButton onClick={(event) => handleOnEdit(item.id)}>
                            <EditIcon
                                fontSize="small"
                                style={{ color: blue[600] }}
                            />
                            </IconButton>
                        }
                        </Avatar>
                        <Avatar className={classes.small}>
                        {
                            <IconButton
                            onClick={(event) => handleOnRemove(item.id)}
                            >
                            <ClearIcon
                                fontSize="small"
                                style={{ color: grey[450] }}
                            />
                            </IconButton>
                        }
                        </Avatar>
                    </div>
                    </TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer> */}
        <DataGrid
            rows={gridRows}
            columns={columns}
            disableSelectionOnClick
            autoHeight={false}
            pageSize={50}
            rowsPerPageOptions={[50, 100, 500]}
            style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
            pagination
        />
        </div>
    </>
  );
};
export default DevicesDocuments;
